import { ExperimentState, ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { withLowerCaseKeys } from "../../helpers";
import { ExperimentActions, experimentActions, Scope } from "../actions";

const initialState: ExperimentState = {
  environmentFeatureGates: {},
  overrideFeatureGates: {},
};

const setFeatureGateOverrides = (
  state: ExperimentState,
  action: ReturnType<typeof experimentActions.setFeatureGateOverrides>
): ExperimentState => ({
  ...state,
  overrideFeatureGates: {
    ...state.overrideFeatureGates,
    ...withLowerCaseKeys(action.featureGates),
  },
});

const setExperimentationInfo = (
  state: ExperimentState,
  action: ReturnType<typeof experimentActions.setExperimentData>
): ExperimentState => {
  const { urlQueryFeatureGates, environmentFeatureGates } = action;

  return {
    ...state,
    environmentFeatureGates: withLowerCaseKeys(environmentFeatureGates),
    overrideFeatureGates: withLowerCaseKeys(urlQueryFeatureGates),
  };
};

export const experimentReducer = withScope(
  Scope.Experiments,
  new ReducerChain(initialState)
    .on(ExperimentActions.SET_FEATURE_GATE_OVERRIDES, setFeatureGateOverrides)
    .on(ExperimentActions.SET_EXPERIMENT_DATA, setExperimentationInfo)
    .build()
);
